import { useQuery } from '@tanstack/react-query';

import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';
import { getBaseUrl } from '@/tscapi/utils/utils';

import { IBrand } from '../IBrands';

export const useBrands = (categoryUrlSlug = '') => {
    const cookie: Cookie = new Cookie();
    return useQuery({
        queryKey: ['brands', cookie.Language, categoryUrlSlug],
        queryFn: () => fetchBrands(categoryUrlSlug),
        useErrorBoundary: true,
        retry: false,
        refetchOnWindowFocus: false,
    });

    async function fetchBrands(categoryUrlSlug): Promise<IBrand[]> {
        const base = getBaseUrl() + '/product/v1/';
        const lang = cookie.Language.substring(0, 2) || 'en';
        let url = `${base}${lang}/brands`;
        if (categoryUrlSlug) {
            url += `/${categoryUrlSlug}`;
        }
        try {
            const response = await http.get<IBrand[]>(url);
            return response.data as IBrand[];
        } catch (error) {
            console.log('Error getting Brands');
            throw new Error('Error getting Brands');
        }
    }
};
